import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { Loader } from '../Loader';
import CustomLink from '../CustomLink';
import styles from './ButtonNew.css';

const cx = classnames.bind(styles);

function ButtonNew(props) {
    const { label, className, onClick, iconLeft, iconRight, type, disabled, link, isLoading, rounded, size, buttonProps, ariaLabel } = props;
    const classes = cx({
        root: true,
        [type]: Boolean(type),
        [className]: Boolean(className),
        withoutLabel: !label,
        rounded,
        [size]: Boolean(size),
        disabled,
        loading: isLoading
    });

    const renderContent = () => (
        <>
            {Boolean(iconLeft?.name) && (
                <Icon
                    name={iconLeft.name}
                    className={styles.icon}
                />
            )}
            {Boolean(iconLeft?.src) && (
                <img
                    src={iconLeft.src}
                    alt={iconLeft.alt}
                    className={styles.image}
                />
            )}
            {label}
            {Boolean(iconRight?.name) && (
                <Icon
                    name={iconRight.name}
                    className={styles.icon}
                />
            )}
            {isLoading && <Loader className={styles.loader} variant={type} />}
        </>
    );

    if (Boolean(link)) {
        return (
            <CustomLink
                className={classes}
                onClick={onClick}
                withDefaultClassName={false}
                ariaLabel={ariaLabel}
                {...link}
            >
                {renderContent()}
            </CustomLink>
        );
    }

    return (
        <button
            className={classes}
            onClick={onClick}
            disabled={disabled}
            {...(buttonProps ? buttonProps : {})}
        >
            {renderContent()}
        </button>
    );
}

ButtonNew.propTypes = {
    iconLeft: PropTypes.object,
    iconRight: PropTypes.object,
    label: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    link: PropTypes.object,
    ariaLabel: PropTypes.string,
    isLoading: PropTypes.bool,
    rounded: PropTypes.bool,
    size: PropTypes.string,
    buttonProps: PropTypes.object
};

ButtonNew.defaultProps = {
    onClick: null,
    className: '',
    iconLeft: null,
    iconRight: null,
    type: 'primary',
    label: '',
    link: null,
    disabled: false,
    isLoading: false,
    rounded: false,
    size: '',
    buttonProps: null
};

export {
    ButtonNew
};
